import { defer, Deferred, Promise } from 'q'

import { runAllSequentially, Task, TaskStatus } from './task'
import { Test } from './test'
import { TestReport } from './test-report'

export class Suite implements Task {
  report: TestReport
  name: string
  tests: Test[] = []
  state: TaskStatus = 'idle'
  opened = false
  runner: any = null

  constructor(report: TestReport, name: string) {
    this.report = report
    this.name = name
  }

  addTest(testName: string, testFunction: any) {
    this.tests.push(new Test(this.report, testName, testFunction))
  }

  run() {
    const deferred = defer()

    this.opened = true
    this.state = 'running'

    this.runner = runAllSequentially(this.tests)
    this.runner.promise
      .then(deferred.resolve, deferred.reject, deferred.notify)
      .finally(this.allTestsFinished.bind(this))

    return deferred.promise
  }

  cancel() {
    this.runner.cancel()
  }

  allTestsFinished() {
    let errors = 0
    let warnings = 0
    let successes = 0

    for (let i = 0; i !== this.tests.length; ++i) {
      errors += this.tests[i].errorCount
      warnings += this.tests[i].warningCount
      successes += this.tests[i].successCount
    }

    if (errors === 0 && warnings === 0 && successes > 0) {
      this.state = 'success'
      this.opened = false
    } else if (errors === 0 && warnings > 0) {
      this.state = 'warning'
      this.opened = false
    } else {
      this.state = 'failure'
      this.opened = true
    }
  }
}

//
//
//

import {
  // Network Connectivity
  HostConnectivityTest,
  ReflexiveConnectivityTest,
  RelayConnectivityTest,
  TcpConnectivityTest,
  UdpConnectivityTest,
  HasIpv6CandidatesTest,

  // Media Throughput
  HostDataChannelThroughputTest,
  ReflexiveDataChannelThroughputTest,
  RelayDataChannelThroughputTest,

  // Media Throughput
  HostVideoBandwidthTest,
  CandidateVideoBandwidthTest,
  ReflexiveVideoBandwidthTest,
  RelayVideoBandwidthTest,

  // Network Latency
  CandicateWiFiPeriodicScanTest,
  ReflexiveWiFiPeriodicScanTest,
  RelayWiFiPeriodicScanTest,

  // Media Support
  MediaAudioTest,
  MediaVideoSDTest,
  MediaVideoMDTest,
  MediaVideoHDTest,
  MediaVideoResolutionsTest,
} from './specs'

export const SUITES = [
  {
    name: 'Network Connectivity',
    tests: [
      {
        name: 'Connectivity - Host',
        spec: HostConnectivityTest,
        enabled: true,
      },
      {
        name: 'Connectivity - STUN Reflexive',
        spec: ReflexiveConnectivityTest,
        enabled: true,
      },
      {
        name: 'Connectivity - TURN Relay',
        spec: RelayConnectivityTest,
        enabled: true,
      },
      {
        name: 'Connectivity - Tcp enabled',
        spec: TcpConnectivityTest,
        enabled: true,
      },
      {
        name: 'Connectivity - Udp enabled',
        spec: UdpConnectivityTest,
        enabled: true,
      },
      {
        name: 'Ipv6 enabled',
        spec: HasIpv6CandidatesTest,
        enabled: true,
      },
    ],
  },
  {
    name: 'Network Throughput',
    tests: [
      {
        name: 'Data throughput - Host',
        spec: HostDataChannelThroughputTest,
        enabled: true,
      },
      {
        name: 'Data throughput - STUN Reflexive',
        spec: ReflexiveDataChannelThroughputTest,
        enabled: true,
      },
      {
        name: 'Data throughput - TURN Relay',
        spec: RelayDataChannelThroughputTest,
        enabled: true,
      },
    ],
  },
  {
    name: 'Media Throughput',
    tests: [
      {
        name: 'Media throughput - Host',
        spec: HostVideoBandwidthTest,
        enabled: true,
      },
      {
        name: 'Media throughput - STUN Reflexive',
        spec: ReflexiveVideoBandwidthTest,
        enabled: true,
      },
      {
        name: 'Media throughput - TURN Relay',
        spec: RelayVideoBandwidthTest,
        enabled: true,
      },
    ],
  },
  {
    name: 'Network Latency',
    tests: [
      {
        name: 'Network Latency - Host',
        spec: CandicateWiFiPeriodicScanTest,
        enabled: true,
      },
      {
        name: 'Network Latency - STUN Reflexive',
        spec: ReflexiveWiFiPeriodicScanTest,
        enabled: true,
      },
      {
        name: 'Network Latency - TURN Relay',
        spec: RelayWiFiPeriodicScanTest,
        enabled: true,
      },
    ],
  },
  {
    name: 'Media Support',
    tests: [
      {
        name: 'Audio capture',
        spec: MediaAudioTest,
        enabled: true,
      },
      {
        name: 'Video capture SD',
        spec: MediaVideoSDTest,
        enabled: true,
      },
      {
        name: 'Video capture MD',
        spec: MediaVideoMDTest,
        enabled: true,
      },
      {
        name: 'Video capture HD',
        spec: MediaVideoHDTest,
        enabled: true,
      },
      {
        name: 'Video capture supported resolutions',
        spec: MediaVideoResolutionsTest,
        enabled: true,
      },
    ],
  },
]
